export default "__VITE_ASSET__7fbbc12a__"